import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import MultiTimer from '../components/timer/MultiTimer';

export default function Timer() {
  return (
    <Box sx={{ width: '100%' }}>
      <Stack direction="row" spacing={2} justifyContent="flex-end" mb={3}>
        <Button
          component={Link}
          to="/pomodoro"
          variant="contained"
          color="primary"
        >
          Try Pomodoro Timer
        </Button>
      </Stack>
      <MultiTimer />
    </Box>
  );
}